export function validateSelectedItem({
  value,
  upcSkuObj: _upcSkuObj,
  originalItems = {},
  itemsCompleted = {},
  itemsRemaining = {},
  currentPackage = {},
}) {
  const upcSkuObj = _upcSkuObj || {}; // it could be null
  let sku = value;
  let scannedUnitOfMeasure;
  // check if they scanned a UPC
  if (!originalItems[sku]) {
    sku = upcSkuObj[value];
    if (sku === null) {
      return {
        error:
          'This UPC matches multiple items on the order. Scan the item SKU instead.',
      };
    }
  }
  const selectedItem = originalItems[sku];
  if (!selectedItem) {
    return {
      error: 'There were no results found with the item number entered.',
      isNotFound: true,
    };
  }
  if (!itemsRemaining[sku]) {
    return {
      error: 'This item was already completed and cannot be processed again.',
    };
  }
  if (value !== sku && value !== selectedItem.upc) {
    const matchingUnits =
      selectedItem.unitOfMeasureDetails?.filter((uom) => uom.upc === value) ??
      [];
    if (matchingUnits.length > 1) {
      return {
        error:
          'This UPC matches multiple units of measure. Scan the item SKU instead.',
      };
    }
    scannedUnitOfMeasure = matchingUnits[0]?.unitOfMeasure;
  }
  // if (currentPackage.items?.[sku]) {
  //   return {
  //     error: 'This item was already scanned.',
  //   };
  // }
  return { data: sku, unitOfMeasure: scannedUnitOfMeasure };
}

export function validateSelectedMaterial({ value }) {
  if (!value) {
    return {
      error: 'There were no results found with the item number entered.',
      isNotFound: true,
    };
  }
  // TODO add logic
  return { data: value };
}
